/*global jQuery*/
(function ($) {
    'use strict';

    var $blockTile = $('div.block-tile__item');

    $blockTile.matchHeight();

}(jQuery));
